import { buildElementObject } from "../shared/buildElementObject";
import { buildNavigationType } from "../shared/buildNavigationType";
import { buildPageObject } from "../shared/buildPageObject";
import { EventAction, EventName } from "../types";

import type { ElementViewEvent, ElementViewInput } from "./types";

type EventBuilder = (input: ElementViewInput) => ElementViewEvent;

const elementViewEventBuilder: EventBuilder = (input) => {
  const { elementName, customProperties } = input;

  const timestamp = new Date().toISOString();

  const elementObject = buildElementObject(elementName);
  const pageObject = buildPageObject();
  const navigationType = buildNavigationType();

  return {
    name: EventName.ElementView,
    action: EventAction.View,
    target: elementObject,
    origin: pageObject,
    navigationType,
    timestamp,
    customProperties,
  };
};

export { elementViewEventBuilder };
